import { Action } from 'helpers/action-helpers';
import { Guid } from 'types/guid';

export const GENERATE_DEVICE_ID = 'GenerateDeviceIdAction';
export const REGISTER_DEVICE = 'RegisterDeviceAction';
export const GET_TENANT_ERROR = 'GetTenantErrorAction';
export const BEGIN_REGISTER_DEVICE = 'BeginRegisterDeviceAction';

export class GenerateDeviceIdAction extends Action {
  constructor() {
    super(GENERATE_DEVICE_ID);
  }
}

export class RegisterDeviceAction extends Action {
  constructor(public tenantId: Guid) {
    super(REGISTER_DEVICE);
  }
}

export class GetTenantErrorAction extends Action {
  constructor(public errorMessage: string) {
    super(GET_TENANT_ERROR);
  }
}
export class BeginRegisterDeviceAction extends Action {
  constructor() {
    super(BEGIN_REGISTER_DEVICE);
  }
}


// WEBPACK FOOTER //
// ./src/pages/device-registration/actions.ts